export default {
    walkInTree(callback, container, runCallBackOnNodeName = null) {
        let startOffset = 0;
        let element = container.firstChild;
        while (element) {
            if (runCallBackOnNodeName === null || element.nodeName === runCallBackOnNodeName) {
                const newEl = callback(element, startOffset);
                if (newEl === false){
                    break
                }
                if (newEl){
                    element = newEl;
                }
            }

            if (element.nodeName === '#text') {
                startOffset += element.textContent.length;
            }

            if (element.hasChildNodes()) {
                element = element.firstChild;
            } else {
                element = this.nextSiblingRecusive(element, container);
            }
        }
    },
    nextSiblingRecusive(element, container) {
        if (container.isSameNode(element)){
            return null
        }
        const nextSibling = element.nextSibling;
        if (!nextSibling){
            return this.nextSiblingRecusive(element.parentNode, container)
        }
        return nextSibling
    }
}
